@switch (mode) {
    @case ("videos") {
        <div class="ebene">
            <div class="video-gallery p-0">
                <div class="row p-0 m-0">
                    <div class="col-md-9 col-12 main-video p-0 m-0">
                        <div
                            class="video-player-comp video-wrapper"
                            style="height: 100%"
                        >
                            <div
                                class="fluid-width-video-wrapper"
                                style="height: 100%"
                            >
                                <iframe
                                    id="ytPlayer"
                                    [src]="currentVid?.url"
                                    allowfullscreen=""
                                    title="YouTube Video"
                                    style="height: 100%; border: 0px"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-12 playlist" id="videoPlaylist">
                        <div class="playlist-items" style="padding-top: 15px">
                            @for (video of videos; track video) {
                                <div
                                    (click)="changeCurrentVid(video)"
                                    (keydown.enter)="changeCurrentVid(video)"
                                    class="playlist-image mb-2 p-0"
                                    [ngClass]="[
                                        currentVid?.url === video.url
                                            ? 'active'
                                            : '',
                                    ]"
                                    [attr.data-href]="video.url"
                                >
                                    <img
                                        [src]="video.urlThumb"
                                        [alt]="'Video: ' + video.bezei"
                                    /><br />
                                    <div class="videoText p-0">
                                        {{ video.bezei }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @case ("images") {
        <div class="image-gallery">
            @for (column of imageColumns; track $index; let colIndex = $index) {
                <div class="image-gallery__column">
                    @for (img of column; track $index; let i = $index) {
                        <button
                            type="button"
                            class="image-gallery__item"
                            [style.flex-grow]="getImageFlexGrow(colIndex, i)"
                            (click)="openLightbox(getImageIndex(colIndex, i))"
                        >
                            <img
                                [src]="img"
                                [attr.alt]="
                                    'Media ' + (getImageIndex(colIndex, i) + 1)
                                "
                            />
                        </button>
                    }
                </div>
            }
        </div>
    }
}
